export default {
  /**
   * 获取已选地址
   * @param {String} type 地址类型
   */
  getCheck: state => type => {
    if (type === "1") {
      return state.sendList;
    } else if (type === "2") {
      return state.acceptList;
    }
  },
  /**
   * 按照ID获取地址
   * @param {String} type 地址类型
   * @param {String} id 地址ID
   */
  getAddressById: state => (type, id) => {
    if (type === "1") {
      return state.sendList.filter(val => val.id === id);
    } else if (type === "2") {
      return state.acceptList.filter(val => val.id === id);
    }
  },
  getOrderSel: state => type => {
    if (type === "1") {
      return state.sendList.filter(val => val.orderCheck);
    } else if (type === "2") {
      return state.acceptList.filter(val => val.orderCheck);
    }
  }
};
